import { render } from "./PlatformConsole.vue?vue&type=template&id=7e6fa3fe&scoped=true"
import script from "./PlatformConsole.vue?vue&type=script&lang=js"
export * from "./PlatformConsole.vue?vue&type=script&lang=js"

import "./PlatformConsole.vue?vue&type=style&index=0&id=7e6fa3fe&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6fa3fe"]])

export default __exports__